<template>
    <div class="home-blog">
        <h2>Blog</h2>

        <div class="home-blog__entries home-blog__entries--desktop" v-if="!isMobile">
            <div class="home-blog__entry">
                <a :href="options[9]" class="d-block swiper-inner-container" target="_blank">
                    <div class="home-blog__img-btn-wrapper">
                        <lazy-img
                                picture-class=""
                                :image-url="options[12]"
                                :alt="options[0]"
                                :title="options[0]">
                        </lazy-img>
                        <div class="home-blog__entry-button"></div>
                        <div class="home-blog__entry-button-txt">{{ options[6] }}</div>
                    </div>

                    <div class="home-blog__entry-content">
                        <div class="home-blog__entry-content-headline">{{ options[0] }}</div>
                        <div class="home-blog__entry-content-txt">{{ options[3] }}</div>
                    </div>
                </a>
            </div>
            <div class="home-blog__entry">
                <a :href="options[10]" class="d-block swiper-inner-container" target="_blank">
                    <div class="home-blog__img-btn-wrapper">
                        <lazy-img
                                picture-class=""
                                :image-url="options[13]"
                                :alt="options[1]"
                                :title="options[1]">
                        </lazy-img>
                        <div class="home-blog__entry-button"></div>
                        <div class="home-blog__entry-button-txt">{{ options[7] }}</div>
                    </div>

                    <div class="home-blog__entry-content">
                        <div class="home-blog__entry-content-headline">{{ options[1] }}</div>
                        <div class="home-blog__entry-content-txt">{{ options[4] }}</div>
                    </div>
                </a>
            </div>
            <div class="home-blog__entry">
                <a :href="options[11]" class="d-block swiper-inner-container" target="_blank">
                    <div class="home-blog__img-btn-wrapper">
                        <lazy-img
                                picture-class=""
                                :image-url="options[14]"
                                :alt="options[2]"
                                :title="options[2]">
                        </lazy-img>
                        <div class="home-blog__entry-button"></div>
                        <div class="home-blog__entry-button-txt">{{ options[8] }}</div>
                    </div>
                    <div class="home-blog__entry-content">
                        <div class="home-blog__entry-content-headline">{{ options[2] }}</div>
                        <div class="home-blog__entry-content-txt">{{ options[5] }}</div>
                    </div>
                </a>
            </div>
        </div>
        <div class="home-blog__entries home-blog__entries--mobil" v-if="isMobile">
            <div class="swiper-container" ref="swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <a :href="options[9]" class="d-block swiper-inner-container" target="_blank">
                            <div class="home-blog__img-btn-wrapper">
                                <lazy-img
                                        picture-class=""
                                        :image-url="options[12]"
                                        :alt="options[0]"
                                        :title="options[0]">
                                </lazy-img>
                                <div class="home-blog__entry-button">
                                    <div class="home-blog__entry-button-txt">{{ options[6] }}</div>
                                </div>
                            </div>

                            <div class="home-blog__entry-content">
                                <div class="home-blog__entry-content-headline">{{ options[0] }}</div>
                                <div class="home-blog__entry-content-txt">{{ options[3] }}</div>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide">
                        <a :href="options[10]" class="d-block swiper-inner-container" target="_blank">
                            <div class="home-blog__img-btn-wrapper">
                                <lazy-img
                                        picture-class=""
                                        :image-url="options[13]"
                                        :alt="options[1]"
                                        :title="options[1]">
                                </lazy-img>
                                <div class="home-blog__entry-button">
                                    <div class="home-blog__entry-button-txt">{{ options[7] }}</div>
                                </div>
                            </div>

                            <div class="home-blog__entry-content">
                                <div class="home-blog__entry-content-headline">{{ options[1] }}</div>
                                <div class="home-blog__entry-content-txt">{{ options[4] }}</div>
                            </div>
                        </a>
                    </div>
                    <div class="swiper-slide">
                        <a :href="options[11]" class="d-block swiper-inner-container" target="_blank">
                            <div class="home-blog__img-btn-wrapper">
                                <lazy-img
                                        picture-class=""
                                        :image-url="options[14]"
                                        :alt="options[2]"
                                        :title="options[2]">
                                </lazy-img>
                                <div class="home-blog__entry-button">
                                    <div class="home-blog__entry-button-txt">{{ options[8] }}</div>
                                </div>
                            </div>
                            <div class="home-blog__entry-content">
                                <div class="home-blog__entry-content-headline">{{ options[2] }}</div>
                                <div class="home-blog__entry-content-txt">{{ options[5] }}</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="home-blog__prev"><i class="icon-left" style="font-size:20px"></i></div>
            <div class="home-blog__next"><i class="icon-right" style="font-size:20px"></i></div>
        </div>
    </div>
</template>

<script>
    import { Swiper } from 'swiper';

    export default{
        props: {
            options: {
                type: Array,
                default: () => []
            }
        },

        data(){
            return {
                isMobile: false
            }
        },

        mounted()
        {
            this.isMobile = window.innerWidth < 768;

            this.$nextTick(() =>
            {
                // swiper mobil
                this.initSwiper();
            });
        },

        methods:{
            initSwiper(){
                if(this.isMobile){
                    // init
                    const swiper = new Swiper(".home-blog__entries .swiper-container", {
                        navigation: {
                            nextEl: ".home-blog__next",
                            prevEl: ".home-blog__prev"
                        },
                        spaceBetween: 10,
                    });
                }
            }
        }
    }
</script>
